import PropTypes from 'prop-types'
import { Component } from 'react'
import { Cell, Legend, Pie, PieChart, Tooltip } from 'recharts'

class DeviceMetricsDoughnutChart extends Component<any, any> {
  static displayName = 'DeviceMetricsDoughnutChart'

  state = {
    activeLabel: {
      name: null
    }
  }

  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    data: PropTypes.array.isRequired,
    nameKey: PropTypes.string,
    dataKey: PropTypes.string
  }

  static defaultProps = {
    animate: false, // Needs to false so labels render correclt: recharts bug
    label: true,
    colors: ['#38BD9F', '#E6A03F', '#618ec6', '#999998', '#F9C248'],
    dataKey: 'value',
    nameKey: 'name',
    height: 250,
    width: 370,
    className: 'doughnut-chart'
  }

  roundPercentage = (percent: any) => {
    const percentage = percent * 100
    const rounded = Math.round(percentage)
    if (percentage > 0 && percentage < 1) return `< ${rounded}%`
    return `${rounded}%`
  }

  roundToNearestThousand = (number: any) => {
    return (number / 1000).toPrecision(2)
  }

  onMouseEnterChart = (data: any) => {
    this.setState({ activeLabel: { name: data.name } })
  }

  onMouseLeaveChart = () => {
    this.setState({ activeLabel: { name: null } })
  }

  onMouseEnterLegend = (entry: any) => {
    this.setState({ activeLabel: { name: entry.value } })
  }

  onMouseLeaveLegend = () => {
    this.setState({ activeLabel: { name: null } })
  }

  determineCellClass = (entry: any, activeLabel: any) => {
    if (!activeLabel.name) return
    else if (activeLabel.name === entry.name) return
    return 'fade' // fade all other chart cells
  }

  determineSectionOpacity = (entry: any, activeSection: any) => {
    if (!activeSection.name) return { transition: '500ms', opacity: '100%' }
    else if (activeSection.name === entry.name) return { transition: '500ms', opacity: '100%' }
    return { transition: '500ms', opacity: '20%' }
  }

  renderTooltip = ({ active, payload }: any) => {
    if (active) {
      return (
        <div className="doughnut-chart-tooltip">
          <p>
            {`${payload[0].name} : `}
            <span>{`${payload[0].value}`}</span>
          </p>
        </div>
      )
    }
  }

  renderLegend = ({ payload }: any) => {
    return (
      <div className="legend-wrapper">
        <table className="chart-legend">
          <tbody>
            {payload.map((entry: any, index: any) => (
              <tr
                onMouseEnter={this.onMouseEnterLegend.bind(this, entry)}
                onMouseLeave={this.onMouseLeaveLegend}
                className="legend-item pointer"
                key={`item-${index}`}
              >
                <td>
                  <div className="legend-icon" style={{ backgroundColor: `${entry.color}` }} />
                </td>
                <td>
                  <span>{entry.value}</span>
                </td>
                <td>
                  <span className="legend-number">{`${this.roundPercentage(entry.payload.percent)}`}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    const { className, width, height, data, animate, colors, dataKey, nameKey } = this.props
    const paddingAngle = data.length > 1 ? 1 : 0
    const { activeLabel } = this.state
    return (
      <PieChart className={className} height={height} width={width}>
        <Legend align="right" layout="vertical" verticalAlign="middle" content={this.renderLegend} />
        <Pie
          data={data}
          innerRadius={45}
          outerRadius={85}
          paddingAngle={paddingAngle}
          dataKey={dataKey}
          nameKey={nameKey}
          isAnimationActive={animate}
          labelLine={false}
          onMouseEnter={this.onMouseEnterChart}
          onMouseLeave={this.onMouseLeaveChart}
        >
          {data.map((entry: any, index: any) => (
            <Cell
              style={this.determineSectionOpacity(entry, activeLabel)}
              className="pointer"
              key={entry}
              fill={colors[index % colors.length]}
            />
          ))}
        </Pie>
        <Tooltip content={this.renderTooltip} />
      </PieChart>
    )
  }
}

export default DeviceMetricsDoughnutChart
